<template>
  <div class="backDiv">
    <div class="bookTitle">
      {{ currentPeriodInfo.Name + "报名回执单" }}
    </div>
    <table class="bookContent">
      <tr>
        <td class="pt80">
          <!-- <p
            class="bookImage"
            v-if="
              currentQueryResult &&
              currentQueryResult.AttachList &&
              currentQueryResult.AttachList.length > 0
            "
          >
            <img :src="currentQueryResult.AttachList[0].url" />
          </p> -->
          <p>姓&emsp;&emsp;名：{{ currentQueryResult.Name }}</p>
          <p>性&emsp;&emsp;别：{{ currentQueryResult.Sex }}</p>
          <p>身份证号：{{ currentQueryResult.IDCard }}</p>
          <p>参训时间：{{ currentPeriodInfo.TrainDateString }}</p>
          <p>参训地点：{{ currentPeriodInfo.Address }}</p>
        </td>
        <td class="pt80">
          <p>人员类别：{{ currentQueryResult.MenTypeName }}</p>
          <p>工作单位：{{ currentQueryResult.WorkSite }}</p>
          <p>职务或工种：{{ currentQueryResult.WorkTypeName }}</p>
          <p>联系电话：{{ currentQueryResult.MobilePhone }}</p>
        </td>
      </tr>
    </table>
    <div v-if="currentPeriodInfo.BackMemo" class="bookBottom">
      {{ currentPeriodInfo.BackMemo }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ReceiptBook",
  data() {
    return {
      currentQueryResult: {},
      currentPeriodInfo: {},
    };
  },
  methods: {
    BackToIndex() {
      this.$router.push("/");
    },
  },
  activated() {
    let cacheData = localStorage.getItem("printReceiptBookData");
    let cacheCurrentPeriodInfoData = localStorage.getItem("currentPeriodInfo");
    if (!cacheData || !cacheCurrentPeriodInfoData) {
      this.$router.push("/");
      return;
    }
    this.currentQueryResult = JSON.parse(cacheData);
    this.currentPeriodInfo = JSON.parse(cacheCurrentPeriodInfoData);
    //console.log(this.currentQueryResult);
    //console.log(this.currentPeriodInfo);
    window.print();
  },
  created() {},
};
</script>
<style scoped>
.pt80 {
  padding-top: 70px !important;
}

.backDiv {
  width: 100%;
  padding: 0px 20px 20px 20px;
}

.bookImage {
  position: absolute;
  top: 85px;
  left: 240px;
}

.bookImage img {
  width: 100px;
}

.bookTitle {
  font-size: 24px;
  text-align: center;
  font-weight: bold;
}

.bookContent {
  width: 100%;
  border: 1px solid black;
  margin-top: 40px;
}

.bookContent td {
  width: 50%;
  height: 280px;
  padding: 29px 9px 9px 9px;
  line-height: 25px;
  vertical-align: top;
}

.bookContent p {
  margin-top: 20px;
}

.bookNotice {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}

.bookBottom {
  margin-top: 20px;
  font-size: 18px;
  font-family: "仿宋";
}
</style>



// WEBPACK FOOTER //
// src/views/ReceiptBook.vue